// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5da425ac","453":"eaaa7677","455":"cb1b9a40","977":"3f37ccb3"}[chunkId] + ".chunk.js";
};